import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { IdType, IdVerificationStatus, LoadingState } from 'types/enums';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getProfileIds,
  getProfileIdsLoadingState,
} from 'app/store/Profile/selectors';
import { returnFromV2VerificationAction } from 'app/store/Mixpanel/slice';
import { config } from 'config';
import { fetchProfileIdsEffect } from 'app/store/Profile/effects';
import { addAlertAction } from 'app/store/Alerts/slice';
import { IdsList } from '../Ids/IdsList';
import { getVerificationStatusMessage } from './utils';

export const ProfileIDs = () => {
  const dispatch = useAppDispatch();
  const profileIds = useAppSelector(getProfileIds);
  const navigate = useNavigate();
  const location = useLocation();
  const profileIdsLoadingState = useAppSelector(getProfileIdsLoadingState);
  const showEmptyState =
    profileIdsLoadingState === LoadingState.FETCHED &&
    profileIds.ipis.length === 0 &&
    profileIds.ipns.length === 0 &&
    profileIds.isnis.length === 0;

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const verificationStatus = parsed?.verificationStatus as IdVerificationStatus;
    const verificationType = parsed?.type as IdType;
    const shouldRefetchIds =
      verificationStatus === IdVerificationStatus.SUCCESS &&
      config.isElectronBuild;
    if (verificationStatus && verificationType) {
      dispatch(returnFromV2VerificationAction());
      const message = getVerificationStatusMessage(
        verificationStatus,
        verificationType
      );
      if (shouldRefetchIds) {
        dispatch(fetchProfileIdsEffect());
      }
      if (message) {
        dispatch(
          addAlertAction({
            message,
          })
        );
      }

      navigate({ search: '' }, { replace: true });
    }
  }, [dispatch, navigate, location.search]);

  return (
    <IdsList
      dispatch={dispatch}
      profileIds={profileIds}
      loading={profileIdsLoadingState === LoadingState.FETCHING}
      showEmptyState={showEmptyState}
    />
  );
};
